import { createAuthClient } from 'better-auth/react'
import { emailOTPClient, phoneNumberClient } from 'better-auth/client/plugins'
import { API_URL } from './api'
export { normalizePhoneInput } from './auth-input'

const authBaseURL = API_URL || (typeof window === 'undefined' ? 'http://localhost:4000' : window.location.origin)

export const authClient = createAuthClient({
  baseURL: authBaseURL,
  basePath: '/api/auth',
  plugins: [emailOTPClient(), phoneNumberClient()],
})
